.form {
	display: flex;
	flex-direction: column;
	padding: 0 4px;
	margin-top: 10px;
}

@media only screen and (max-width: 860px) {
	.form {
		margin-top: 20px;
		padding: 0 16px;
	}
}

.containerLoggedIn {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	margin-top: 14px;
}

.containerLoggedInMobile {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.displayName {
	margin-right: 8px;
}

.input {
	padding: 5px 8px;
	margin-bottom: 8px;
	font-size: 16px;
	background-color: beige;
}

.submitButton {
	margin-top: 12px;
	border-width: 0;
	border-radius: 6px;
	padding: 6px 2px 6px 2px;
	background-color: #0f9b9d;
	cursor: pointer;
	color: rgb(245, 245, 245);
	font-size: 18px;
}

.logout_button {
	margin-top: 4px;
	border-width: 0;
	border-radius: 6px;
	padding: 6px 2px 6px 2px;
	background-color: transparent;
	cursor: pointer;
	color: rgb(210, 210, 210);
	font-size: 16px;
}

.logout_button.mobile {
	margin-top: 0;
	color: rgba(255, 0, 0, 0.6);
}
